import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

const ReservationContext = createContext({
  isOpen: false,
  prefill: null,
  open: () => {},
  close: () => {}
});

export const ReservationProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const open = useCallback((data = null) => {
    setPrefill(data);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setPrefill(null);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen, close]);

  return (
    <ReservationContext.Provider value={{ isOpen, prefill, open, close }}>
      {children}
    </ReservationContext.Provider>
  );
};

export const useReservation = () => useContext(ReservationContext);
